<script lang="ts" setup>
    import { type JourneyStats } from '@journeys/journeys';
    import { onMounted, ref, computed } from 'vue';
    import { GetJourneyStats } from '@journeys/Journey.access';
    import { formatNumericText } from '@cwd/Shared/utils/formatNumericText';

    const props = defineProps<{
        journeyId: string;
    }>();

    const mailingStats = ref<JourneyStats | null>(null);
    const loading = ref(true);

    onMounted(async () => {
        mailingStats.value = await GetJourneyStats(props.journeyId);
        loading.value = false;
    });

    const getContactCount = computed(() => {
        if (!mailingStats.value) return 0;
        return mailingStats.value.ContactCount;
    });

    const getRecipientCount = computed(() => {
        if (!mailingStats.value) return 0;
        return mailingStats.value.RecipientCount;
    });

    const getOpenedPercentage = computed(() => {
        if (!mailingStats.value) return 0;
        return mailingStats.value.OpenedPercentage;
    });

    const getClickedPercentage = computed(() => {
        if (!mailingStats.value) return 0;
        return mailingStats.value.ClickedPercentage;
    });
</script>

<template>
    <div class="card-content align-self-center">
        <div class="d-flex flex-wrap col-gap-md align-items-end ug-bars">
            <div style="max-width: 64px" v-tooltip.top="$Resources.JourneyListStatsContactsLabel + ': ' + getContactCount">
                <div class="bar-label">
                    {{ $Resources.JourneyListStatsContactsLabel }}
                    <span class="skeleton" :class="loading && 'loading'">
                        {{ formatNumericText(getContactCount, { precision: 0, largeNumbers: true }) }}
                    </span>
                </div>
                <div class="bar o-0">
                    <span class="bar-value"></span>
                </div>
            </div>
            <div v-tooltip.top="$Resources.JourneyListStatsRecipientsLabel + ': ' + getRecipientCount">
                <div class="bar-label">
                    {{ $Resources.JourneyListStatsRecipientsLabel }}
                    <span class="skeleton" :class="loading && 'loading'">
                        {{ formatNumericText(getRecipientCount, { precision: 0, largeNumbers: true }) }}
                    </span>
                </div>
                <div class="bar o-0">
                    <span class="bar-value"></span>
                </div>
            </div>
            <div>
                <div class="bar-label">
                    {{ $Resources.JourneyListStatsOpenLabel }}
                    <span class="skeleton" :class="loading && 'loading'">{{ Math.round(getOpenedPercentage) }}%</span>
                </div>
                <div class="bar">
                    <span class="bar-value bg-opened" :style="{ width: Math.round(getOpenedPercentage) + '%' }"></span>
                </div>
            </div>
            <div>
                <div class="bar-label">
                    {{ $Resources.JourneyListStatsClickedLabel }}
                    <span class="skeleton" :class="loading && 'loading'">{{ Math.round(getClickedPercentage) }}%</span>
                </div>
                <div class="bar">
                    <span class="bar-value bg-clicked" :style="{ width: Math.round(getClickedPercentage) + '%' }"></span>
                </div>
            </div>
        </div>
    </div>
</template>
